export const getTexts = state => state.launchProgressBarReducer.texts
export const getProgressText = (state, progress) => {
    const texts = getTexts(state)
    const progressStates = {
        0: 'notStarted',
        1: 'processStarted',
        10: 'authorizing',
        50: 'authorizationFailed',
        60: 'refresh',
        70: 'refresh',
        80: 'authorizing',
        100: 'starting',
    }
    const index = progressStates[progress] || 'notStarted'
    return texts[index] || ''
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/data/texts/selectors.js